import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteImagesContext = createContext({});

export const SiteImagesProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({});
  useEffect(() => {
    api.get("/site-images").then(({ data }) => setOverrides(data || {})).catch(() => {});
  }, []);
  return <SiteImagesContext.Provider value={overrides}>{children}</SiteImagesContext.Provider>;
};

export const useSiteImage = (key, fallback) => {
  const overrides = useContext(SiteImagesContext);
  return (key && overrides[key]) || fallback;
};
